export const navTabCustomStyles = {
  padding: '0 16px',

  '&[aria-selected="true"] .nav-tab-label': {
    fontWeight: 700,
    color: ({ palette }) => palette.primary.main,
  },
};

export const navTextWrapperStyles = {
  display: 'flex',
  width: '100%',
  overflow: 'hidden',
  alignItems: 'center',

  '&[data-is-deleted="true"]': {
    textDecoration: 'line-through',
  },

  '&:hover .nav-tab-button': {
    display: 'block',
  },
};

export const navTabButtonStyles = {
  display: 'none',
};

export const navTextContentStyles = {
  display: 'flex',
  gap: '4px',
  flex: 1,
  alignItems: 'center',
  position: 'relative',
  height: '100%',
};

export const navTextStyles = {
  maxWidth: '100%',
  width: 'fit-content',
  color: ({ palette }) => palette.text.dark,
  whiteSpace: 'normal',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  textAlign: 'start',
};

export const pendingChangesCounterStyles = {
  flexShrink: 0,
  marginRight: '10px',

  '& .pending-changes-count': {
    fontWeight: 400,
  },
};
